import { type ReactNode } from 'react';
import { useLocation } from 'react-router-dom';

import { ErrorBoundary } from '@/ui/error-boundary';

interface RouteErrorBoundaryProps {
    children: ReactNode;
}

export function RouteErrorBoundary({ children }: RouteErrorBoundaryProps) {
    const location = useLocation();
    return <ErrorBoundary key={location.key}>{children}</ErrorBoundary>;
}
